import {useTheme} from "@/hooks/useTheme";
import clsxm from "@/lib/clsxm";
import type {FC, Ref} from "react";
import {Tooltip as ReactTooltip, type ITooltip, type TooltipRefProps} from "react-tooltip";

export type {PlacesType} from "react-tooltip";

export const Tooltip: FC<ITooltip & {ref?: Ref<TooltipRefProps>}> = ({className, opacity = 1, variant, ...props}) => {
  const {resolvedTheme} = useTheme();
  const themedVariant = variant === "light" ? (resolvedTheme === "dark" ? "dark" : "light") : variant;

  return <ReactTooltip className={clsxm("z-10000", className)} opacity={opacity} variant={themedVariant} {...props} />;
};
